import dayjs from 'dayjs';
import type { ModelPlanPayment } from '@layup/api-sdk';

export const getPaymentStatus = (payment: ModelPlanPayment) => {
  if (payment.failed) {
    return 'Failed';
  } else if (payment.paymentType === 'REFUND') {
    return 'Refunded';
  } else if (payment.paid && !payment.reconciliated) {
    return 'Pending';
  } else if (payment.paid) {
    return 'Paid';
  } else if (dayjs().isAfter(payment.dueAt)) {
    return 'Overdue';
  } else if (dayjs().isSame(payment.dueAt, 'day')) {
    return 'Due';
  } else {
    return 'Upcoming';
  }
};

export const getPaymentStatusVariant = (status: string) => {
  let variant:
    | 'destructive'
    | 'outline'
    | 'secondary'
    | 'default'
    | 'warning'
    | 'brand'
    | 'success'
    | 'info'
    | 'error'
    | null
    | undefined = undefined;

  switch (status) {
    case 'Refunded':
      variant = 'warning';
      break;
    case 'Pending':
      variant = 'info';
      break;
    case 'Paid':
      variant = 'success';
      break;
    case 'Overdue':
      variant = 'error';
      break;
    case 'Due':
      variant = 'warning';
      break;
    case 'Failed':
      variant = 'error';
      break;
    case 'Upcoming':
      variant = 'outline';
      break;
    default:
      variant = 'default';
      break;
  }
  return variant;
};
